import { Modal, Box, Typography, SxProps } from "@mui/material";
import { priceFormatter } from "../../../utils/priceFormatter";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { SecondaryButton } from "../buttons/SecondaryButton";
import { useTranslation } from "react-i18next";

interface ScheduilingModalProps {
  open: any;
  onClose: any;
  date: string;
  timeSelected: string;
  price: number;
  onConfirm: any;
}

const ScheduilingModal = (props: ScheduilingModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box sx={styles.modal}>
        <Typography variant="h6" component="h2" fontWeight="bold">
          {t("appointmentDetails.schedulingModal.title")}
        </Typography>
        <Box sx={styles.buttonsContainer}>
          <Typography>
          <span style={{ fontWeight: 600 }}>
            {t("appointmentDetails.schedulingModal.day")}{" "}
          </span>
            {props.date}
          </Typography>
          <Typography>
          <span style={{ fontWeight: 600 }}>
            {t("appointmentDetails.schedulingModal.time")}{" "}
          </span>
            {props.timeSelected}
          </Typography>
        </Box>

        <Typography
          variant="h5"
          fontWeight="bold"
          color="primary"
        >{`R$ ${priceFormatter(props.price)}`}</Typography>

        <Box sx={styles.buttonsContainer}>
          <Box>
            <PrimaryButton
              label={t("appointmentDetails.schedulingModal.confirm")}
              onClickAction={props.onConfirm}
              styles={{ maxHeight: "40px" }}
            />
          </Box>
          <Box>
          <SecondaryButton
              onClickAction={props.onClose}
              label={t("appointmentDetails.schedulingModal.cancel")}
          />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ScheduilingModal;

const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "25px",
    bgcolor: "background.paper",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  } as SxProps,

  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  } as SxProps,
};
